import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import { Purchase, PurchaseStatus } from '@Purchasing/Domain/Model/PurchaseProcess'
import {
    CreatePurchasePayload,
    UpdatePurchasePayload,
} from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'

export interface GetPurchaseByProcess {
    execute(processId: string): Promise<Purchase | null>
}

export class GetPurchaseByProcessUseCase implements GetPurchaseByProcess {
    constructor(private repository: PurchasingRepository) {}
    execute(processId: string): Promise<Purchase | null> {
        return this.repository.getPurchase(processId)
    }
}

export interface CreatePurchase {
    execute(
        processId: string,
        payload?: CreatePurchasePayload
    ): Promise<Purchase>
}

export class CreatePurchaseUseCase implements CreatePurchase {
    constructor(private repository: PurchasingRepository) {}
    execute(
        processId: string,
        payload?: CreatePurchasePayload
    ): Promise<Purchase> {
        return this.repository.createPurchase(processId, payload)
    }
}

export interface UpdatePurchaseOp {
    execute(
        processId: string,
        payload: UpdatePurchasePayload
    ): Promise<Purchase>
}

export class UpdatePurchaseUseCase implements UpdatePurchaseOp {
    constructor(private repository: PurchasingRepository) {}
    execute(
        processId: string,
        payload: UpdatePurchasePayload
    ): Promise<Purchase> {
        return this.repository.updatePurchase(processId, payload)
    }
}

export interface ChangePurchaseStatus {
    execute(processId: string, status: PurchaseStatus): Promise<Purchase>
}

export class ChangePurchaseStatusUseCase implements ChangePurchaseStatus {
    constructor(private repository: PurchasingRepository) {}
    execute(processId: string, status: PurchaseStatus): Promise<Purchase> {
        return this.repository.updatePurchaseStatus(processId, status)
    }
}
